import { useRouter } from 'next/router'
import ForgotPasswordForm from '../../components/Account/ForgotPasswordForm'
import MainLayout from '../../components/MainLayout/MainLayout'
import styles from '../../styles/Home.module.css'
import getServerSideAccessToken from '@utilities/auth/server/getServerSideAccessToken'
import Form from '@components/Form'

export default function ForgotPassword() {
  const router = useRouter()
  const { hash } = router.query

  return (
    <div className={styles.container}>
      <MainLayout title="Forgot Password">
        {!hash ? <ForgotPasswordForm /> : <Form.ResetPassword />}
      </MainLayout>
    </div>
  )
}

export async function getServerSideProps(context: any) {
  const token = await getServerSideAccessToken(context, false)
  if (token)
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  return { props: {} }
}
